import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3e0e0b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = ["id", "value", "name", "type", "placeholder", "required", "pattern"]

import InputLabel from "@/components/forms/InputLabel.vue";
import InputErrorMessage from "@/components/forms/InputErrorMessage.vue";
import { useRestrictNumberInput } from "@/composables";

import {
  FormFieldNameEnum,
  FormFieldType,
  FormInputErrorMessageTypeEnum,
} from "@/types/form";
import { getFormattedThousandsString } from "@/utils/modifiers";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import Icon from "../icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

interface Props {
  modelValue: string;
  name: FormFieldNameEnum;
  placeholder?: string;
  pattern?: string;
  label?: string;
  type?: FormFieldType;
  required?: boolean;
  // errors?: ErrorsFieldObject["errors"];
  errors?: any;
  hideErrorMessage?: boolean;
  isChecked?: boolean;
}

interface Emits {
  (e: "update:modelValue", value: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    modelValue: { default: "" },
    name: { default: FormFieldNameEnum.Name },
    placeholder: { default: "" },
    pattern: { default: "" },
    label: { default: "" },
    type: { default: FormFieldType.Text },
    required: { type: Boolean, default: false },
    errors: { default: undefined },
    hideErrorMessage: { type: Boolean, default: false },
    isChecked: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();

const props = __props;

const error = computed<string>(() => {
  let err = FormInputErrorMessageTypeEnum.None;
  if (!props.errors) {
    return err;
  }

  const inputName = props.name;
  const currentError = props.errors[inputName];

  if (currentError) {
    return t(`auth.errors.${currentError}`);
  }

  return err;
});

const handleInputEmit = (event: Event): void => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
};

const appliedValue = computed<string>(() => {
  let value = props.modelValue;
  if (props.type === FormFieldType.Tel) {
    value = getFormattedThousandsString(value);
  }
  return value;
});

const { handleKeyDown, handleInput } = useRestrictNumberInput(
  props.type,
  handleInputEmit,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(InputLabel, {
          key: 0,
          name: _ctx.name,
          label: _ctx.label
        }, null, 8, ["name", "label"]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: _ctx.name,
      ref: _ctx.name,
      autocomplete: "off",
      autocorrect: "off",
      autocapitalize: "off",
      class: "input",
      value: appliedValue.value,
      name: _ctx.name,
      type: _ctx.type,
      placeholder: _ctx.placeholder ? _ctx.$t(_ctx.placeholder) : undefined,
      required: _ctx.required,
      pattern: _ctx.pattern ? _ctx.pattern : undefined,
      onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleKeyDown) && _unref(handleKeyDown)(...args))),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleInput)($event as InputEvent)))
    }, null, 40, _hoisted_2),
    (_ctx.isChecked)
      ? (_openBlock(), _createBlock(Icon, {
          key: 1,
          icon: _unref(IconType).CHECKMARK,
          class: "is-checked"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    (!_ctx.hideErrorMessage)
      ? (_openBlock(), _createBlock(InputErrorMessage, {
          key: 2,
          "error-message": error.value
        }, null, 8, ["error-message"]))
      : _createCommentVNode("", true)
  ]))
}
}

})